<form [formGroup]="frmGrp" (ngSubmit)="save()" #formRef="ngForm">
  <div class="container">
    <div class="dialog-title">Tab Options</div>

    <div class="value-container" fxLayout="column" style="padding-bottom: 10px">
      <section>
        <label class="leadNotification">Unit Status</label>
      </section>

      <section class="subCheckbox">
        <mat-checkbox
          class="leadNotCheck"
          color="primary"
          formControlName="booked"
          (change)="updateNotificationFields(['bookingInfo','overallSiteProgressBooked','loan'],$event)"
        >
          Booked
        </mat-checkbox>
        <div class="bookingNotification">
          <mat-checkbox
            class="bookingNotCheck"
            color="primary"
            formControlName="bookingInfo"
          >
            Booking Info
          </mat-checkbox>
          <mat-checkbox
            class="bookingNotCheck"
            color="primary"
            formControlName="overallSiteProgressBooked"
          >
            Overall Site Progress
          </mat-checkbox>
          <mat-checkbox
            class="bookingNotCheck"
            color="primary"
            formControlName="loan"
          >
            Loan
          </mat-checkbox>
        </div>

        <mat-checkbox
          class="leadNotCheck"
          color="primary"
          formControlName="signed"
          (change)="updateNotificationFields(['s_and_p','overallSiteProgressSigned','accounts','keyCollection'],$event)"
        >
          SPA Signed
        </mat-checkbox>
        <div class="bookingNotification">
          <mat-checkbox
            class="bookingNotCheck"
            color="primary"
            formControlName="s_and_p"
          >
            S & P
          </mat-checkbox>
          <mat-checkbox
            class="bookingNotCheck"
            color="primary"
            formControlName="overallSiteProgressSigned"
          >
            Overall Site Progress
          </mat-checkbox>
          <mat-checkbox
            class="bookingNotCheck"
            color="primary"
            formControlName="accounts"
          >
            Accounts
          </mat-checkbox>
          <mat-checkbox
            class="bookingNotCheck"
            color="primary"
            formControlName="keyCollection"
          >
            Key Collection
          </mat-checkbox>
        </div>
      </section>
    </div>

    <div class="dialog-title">Interested Purchaser</div>

    <div class="value-container" fxLayoutAlign="space-between end">
      <mat-radio-group
        formControlName="purchaser_app_setting"
        fxLayout="row"
        fxLayoutGap="16px"
      >
        <ng-container *ngFor="let type of purchaserSetting | keyvalue">
          <mat-radio-button [disableRipple]="true" [value]="type.key">
            {{ type.value }}
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>
    </div>
  </div>

  <div class="dialog-buttons">
    <button mat-button color="primary" [mat-dialog-close]="false">
      Cancel
    </button>
    <button mat-button color="primary" (click)="save()">Save</button>
  </div>
</form>
